export default __webpack_public_path__ + "static/media/Shadow.ccdde082.png";